import { render, staticRenderFns } from "./ValidacaoRepasse.vue?vue&type=template&id=076c160d&"
import script from "./ValidacaoRepasse.vue?vue&type=script&lang=js&"
export * from "./ValidacaoRepasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports